<a class="fc-powered-by-logo" target="_blank" href="https://www.savrr.com" rel="nofollow" >
    <span class="fc-power-by-text">This comparison service is powered by</span>
    <img width="120" height="31" loading="lazy"
        [src]="logoSrc" 
        alt="SAVRR - white label comparison technology provider">
</a>